import { UserService } from "../services/user";
import RDP_CONFIG from '../config';

var workflowsService = function () {
  this.getProcesses = function (filter) {
    var user = UserService.getUser();
    var connector = UserService.getConnectorByName("Workflow");

    if (filter !== undefined) {
      filter = "&filter_outputs=" + filter
    } else {
      filter = "";
    };
    
    return new Promise(function (resolve, reject) {
      // fetch(`https://${RDP_CONFIG.domain}/cms/v1.1/workflows/connector/uid/${connector.uid}/management?include_steps=true`, {
        fetch(`https://${RDP_CONFIG.domain}/cms/v1.1/workflows/connector/uid/${connector.uid}/management/group?include_properties=true${filter}`, {
        method: "GET",
        headers: {
          "Authorization": "Bearer " + user.access_token,
          "Project-Key" : RDP_CONFIG.projectKey,
          "Api-Env" : RDP_CONFIG.apiEnv
        }
      }).then(function(response) {
        return response.json();
      }).then(function(data) {
        resolve(data)
      }, function (error) {
        reject(error)
      });
    })
  }

  this.getDemandsByObject = function (groupUid) {
    var user = UserService.getUser();
    var connector = UserService.getConnectorByName("Workflow");
    // {{DomainCmsV1.1}}/workflows/workitem/uid/{{WorkItemUid}}/management?include_steps=true&include_flows=true
    return new Promise(function (resolve, reject) {
        fetch(`https://${RDP_CONFIG.domain}/cms/v1.1/workflows/workitem/uid/${groupUid}/management?include_steps=true&include_flows=true&include_properties=true`, {
        method: "GET",
        headers: {
          "Authorization": "Bearer " + user.access_token,
          "Project-Key" : RDP_CONFIG.projectKey,
          "Api-Env" : RDP_CONFIG.apiEnv
        }
      }).then(function(response) {
        return response.json();
      }).then(function(data) {
        resolve(data)
      }, function (error) {
        reject(error)
      });
    })
  }

  // this.getWorkflows = function (projectUid) {
  //   return new Promise(function (resolve, reject) {
  //     fetch(`http://localhost:3000/rdpmanager/workflows/${projectUid}`, {
  //       method: "GET",
  //       headers: {
  //         // "session_token": AuthenticationService.getUser() && AuthenticationService.getUser().session_token,
  //         "Accept": "application/json",
  //         "Content-Type": "application/json"
  //       }
  //     }).then(function(response) {
  //       return response.json();
  //     }).then(function(data) {
  //       resolve(data)
  //     }, function (error) {
  //       reject(error)
  //     });
  //   })
  // }

  this.getWorkflow = function (objectId) {
    return new Promise(function (resolve, reject) {
      fetch(`http://localhost:3000/rdpmanager/workflow/${objectId}`, {
        method: "GET",
        headers: {
          // "session_token": AuthenticationService.getUser() && AuthenticationService.getUser().session_token,
          "Accept": "application/json",
          "Content-Type": "application/json"
        }
      }).then(function(response) {
        return response.json();
      }).then(function(data) {
        resolve(data)
      }, function (error) {
        reject(error)
      });
    })
  }

  this.post = function (groupUid, deadline, name, goal, objectType) {
    var user = UserService.getUser();

    return new Promise(function (resolve, reject) {
      fetch(`https://${RDP_CONFIG.domain}/cms/v1.1/workflows/group/uid/${groupUid}/management/workitem`, {
        method: "POST",
        headers: {
          "Authorization": "Bearer " + user.access_token,
          "Project-Key" : RDP_CONFIG.projectKey,
          "Api-Env" : RDP_CONFIG.apiEnv
        },
        body: JSON.stringify({
          "deadline_at" : deadline, //"2023-12-20"
          "properties" : [{
            "name": "Nome",
            "type": objectType,
            "value": name
          }, {
            "name": "Objetivo",
            "type": objectType,
            "value": goal
          }]
        })
      }).then(function(response) {
        return response.json();
      }).then(function(data) {
        resolve(data)
      }, function (error) {
        reject(error)
      });
    })
  }

  this.changeStepStatus = function (stepUid, status) {
    var user = UserService.getUser();
    return new Promise(function (resolve, reject) {
      fetch(`https://${RDP_CONFIG.domain}/cms/v1.1/workflows/workitem/uid/${stepUid}/management/state`, {
        method: "PUT",
        headers: {
          "Authorization": "Bearer " + user.access_token,
          "Project-Key" : RDP_CONFIG.projectKey,
          "Api-Env" : RDP_CONFIG.apiEnv
        },
        body: JSON.stringify({
          "state": status
        })
      }).then(function(response) {
        return response.json();
      }).then(function(data) {
        resolve(data)
      }, function (error) {
        reject(error)
      });
    })
  }

  // this.post = function (projectUid) {
  //   return new Promise(function (resolve, reject) {
  //     fetch(`http://localhost:3000/rdpmanager/workflows/`, {
  //       method: "POST",
  //       headers: {
  //         "Accept": "application/json",
  //         "Content-Type": "application/json"
  //       },
  //       body: JSON.stringify({
  //         "project_uid": projectUid
  //       })
  //     }).then(function(response) {
  //       return response.json();
  //     }).then(function(data) {
  //       resolve(data)
  //     }, function (error) {
  //       reject(error)
  //     });
  //   })
  // }

  this.put = function (id, model) {
    return new Promise(function (resolve, reject) {
      fetch(`http://localhost:3000/rdpmanager/workflow/` + id, {
        method: "PUT",
        headers: {
          "Accept": "application/json",
          "Content-Type": "application/json"
        },
        body: JSON.stringify(model)
      }).then(function(response) {
        return response.json();
      }).then(function(data) {
        resolve(data)
      }, function (error) {
        reject(error)
      });
    })
  }

  this.delete = function (id) {
    return new Promise(function (resolve, reject) {
      fetch(`http://localhost:3000/rdpmanager/workflow/` + id, {
        method: "DELETE",
        headers: {
          "Accept": "application/json",
          "Content-Type": "application/json"
        },
      }).then(function(response) {
        return response.json();
      }).then(function(data) {
        resolve(data)
      }, function (error) {
        reject(error)
      });
    })
  }

  return this;
}

var WorkflowsService = new workflowsService();

export {
  WorkflowsService
};